<template>
  <div class="pacs-container-entity pacs-container-entity_column">
    <SpinnerLoadingModal v-if="isLoading" />
    <p v-else-if="errorLoadEntity">
      {{ $t('errorLoadEntity') }}
    </p>
    <template v-else>
      <div class="input-row">
        <div><strong>{{ $t('deviceName') }}:</strong> {{ dataForm.title }}</div>
        <div>
          <strong>{{ $t('deviceState') }}:</strong>
          {{ dataForm.isActive ? $t('active') : $t('inactive') }}
        </div>
        <div>
          <strong>{{ $t('emergencyVehicleAccess') }}:</strong>
          {{ dataForm.emergencyVehicleAccess ? $t('available') : $t('notAvailable') }}
        </div>
        <div>
          <strong> {{ $t('cameraCountForDevice') }}:</strong>
          {{ dataForm.cameraCount }}
        </div>
        <div>
          <strong>  {{ $t('availableCamerasForUser') }}:</strong>
          {{ listCamerasInfo.length }}
        </div>
      </div>

      <div v-if="dataForm.cameraCount">
        <div v-if="listCamerasInfo.length" class="mesh-cameras-grid mesh-cameras-grid_tiles">
          <ViewTile
            v-for="cameraInfo in listCamerasInfo"
            :key="cameraInfo.number"
            :camera-info="cameraInfo"
            class="mesh-cameras-grid__cell"
          >
            {{ cameraInfo.number }}
          </ViewTile>
        </div>
      </div>
      <div v-else class="input-row">
        {{ $t('noCamerasAttachedToDevice') }}
      </div>

      <div class="buttons-group">
        <CamsButton
          type="button"
          @click="openDialogSetPermissionsForEmployees()"
        >
          {{ $t('editPermissionsForEmployees') }}
        </CamsButton>

        <CamsButton
          type="button"
          @click="openDialogSetPermissionsForDeviceAccessGroups()"
        >
          {{ $t('editPermissionsForDeviceAccessGroups') }}
        </CamsButton>
        <CamsButton
          type="button"
          @click="openDialogEditDeviceBlackList()"
        >
          Блокировка пользователей
        </CamsButton>
      </div>
    </template>
  </div>
</template>

<script>
import ViewTile from "@/components/meshCameras/ViewTile.vue";
import SetPermissionsForEmployees from "@/components/pacs/pacsPermissions/SetPermissionsForEmployees.vue";
import SetPermissionsForDeviceAccessGroups from "@/components/pacs/pacsPermissions/SetPermissionsForDeviceAccessGroups.vue";
import {ACTION_LOAD_DEVICE_FOR_EDIT, DEVICE_STRUCT} from "@/store/pacs/devices/index.js";
import {editEntityMixin} from "@/components/pacs/mixins.js";
import {ACTION_LOAD_CAMERAS, FIELDS_CAMERA} from "@/store/cameras/index.js";
import EditDeviceBlackList from "@/components/pacs/devices/EditDeviceBlackList.vue";

export default {
  mixins: [editEntityMixin],
  components: {
    ViewTile
  },
  data() {
    const deviceId = Number(this.$route.params.deviceId);

    return {
      entityId: deviceId,
      actionForLoadEntity: `pacs/devices/${ACTION_LOAD_DEVICE_FOR_EDIT}`,
      dataForm: {
        ident: null,
        title: null,
        cameraCount: 0,
        cameraNumbers: [],
        isActive: false,
      },
      listCamerasInfo: [],
    };
  },
  methods: {
    /**
     * Получение перечня камер доступных камер на текущем устройстве доступа.
     */
    async afterLoadSourceData() {
      this.dataForm = {
        ident: this.sourceData.entityInfo[DEVICE_STRUCT.fields.ident.name],
        title: this.sourceData.entityInfo[DEVICE_STRUCT.fields.title.name],
        emergencyVehicleAccess: this.sourceData.entityInfo[DEVICE_STRUCT.fields.emergency_vehicle_access.name],
        cameraCount: this.sourceData.entityInfo[DEVICE_STRUCT.fields.camera_count.name],
        cameraNumbers: this.sourceData.entityInfo[DEVICE_STRUCT.fields.camera_numbers.name],
        isActive: this.sourceData.entityInfo[DEVICE_STRUCT.fields.is_active.name],
      };

      this.listCamerasInfo = [];
      if (!_.isEmpty(this.dataForm.cameraNumbers)) {
        this.listCamerasInfo = await this.$store.dispatch(`cameras/${ACTION_LOAD_CAMERAS}`, {
          fields: [
            FIELDS_CAMERA.number,
            FIELDS_CAMERA.address,
            FIELDS_CAMERA.title,
            FIELDS_CAMERA.timezone,
            FIELDS_CAMERA.analytics,
            FIELDS_CAMERA.is_public,
            FIELDS_CAMERA.inactivity_period,
            FIELDS_CAMERA.server,
            FIELDS_CAMERA.token_l,
            FIELDS_CAMERA.tariff,
            FIELDS_CAMERA.permission
          ],
          numbers: this.dataForm.cameraNumbers,
        });
        devLog(this.listCamerasInfo);
      }
    },
    /**
     * Открытие формы для изменения прав сотрудника на устройство.
     */
    openDialogSetPermissionsForEmployees() {
      this.$camsdals.open(
        SetPermissionsForEmployees,
        {deviceId: this.entityId},
        {dialogTitle: this.$t('editAccessSettings')},
        {name: "js-click-outside"}
      );
    },
    openDialogSetPermissionsForDeviceAccessGroups() {
      this.$camsdals.open(
        SetPermissionsForDeviceAccessGroups,
        {deviceId: this.entityId},
        {dialogTitle: this.$t('editAccessSettings')},
        {name: "js-click-outside"}
      );
    },
    openDialogEditDeviceBlackList () {
      this.$camsdals.open(
        EditDeviceBlackList,
        {deviceId: this.entityId},
        {dialogTitle: "Блокировка пользователей"},
        {name: "js-click-outside",
         size: "vuedal-auto-width",
        }
      );
    },
  }
};
</script>
<style scoped>
.pacs-container-entity {
  width: 60%;
  margin: 0 0 0 -10px;
  padding: 20px;
  min-height: 100vh;
}

.input-row {
  background: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  border-left: 4px solid #2F84F8;
}

.input-row div {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}


</style>
